import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttosolapur() {



  const cardData =
  {
    keyword: 'Mumbai to Solapur Cab',
    heading: 'Shambhu Cabs: Mumbai to Solapur Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Solapur Cab services, providing safe, comfortable, and hassle-free long-distance travel for families, corporate travelers, business groups, and tourists. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Solapur with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes intercity travel convenient, stress-free, and dependable. For comfort, safety, and a trusted Mumbai to Solapur cab experience, Shambhu Cabs is your reliable travel partner.',

    top: 'Top Places to Visit in Solapur with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple, located in Solapur, is dedicated to Lord Siddheshwar, a revered form of Shiva. The temple features intricate architecture, peaceful surroundings, and a sacred pond where devotees perform rituals. The temple hosts vibrant celebrations during festivals like Maha Shivaratri, attracting pilgrims from across Maharashtra. It is considered the spiritual heart of Solapur and a hub for local religious activities."
  },
  {
    "title": "Solapur Fort",
    "description": "Solapur Fort is a historic fortification built during the 14th century, reflecting the city’s strategic importance. The fort features robust stone walls, ancient gateways, and remnants of royal structures. Visitors can explore the fort’s architecture, enjoy panoramic views of Solapur city, and learn about its history under various rulers including the Bahmani and Nizam dynasties. It’s a must-visit for history enthusiasts."
  },
  {
    "title": "Great Indian Bustard Sanctuary",
    "description": "Located near Solapur, the Great Indian Bustard Sanctuary is a wildlife reserve dedicated to conserving the critically endangered Great Indian Bustard. Visitors can witness diverse bird species, dry grassland habitats, and engage in eco-tourism activities. The sanctuary is perfect for bird watchers, nature photographers, and wildlife enthusiasts seeking an offbeat natural experience near Solapur."
  },
  {
    "title": "Akkalkot Swami Samarth Temple",
    "description": "Situated near Solapur, Akkalkot is famous for the Samarth Maharaj Temple, dedicated to the 19th-century saint Swami Samarth. Devotees from across India visit for darshan, spiritual guidance, and blessings. The temple complex includes a large hall, gardens, and facilities for pilgrims, making it a significant spiritual and cultural center close to Solapur."
  },
  {
    "title": "Bhuikot Fort",
    "description": "Bhuikot Fort is an ancient fort in Solapur city, known for its historical significance and medieval architecture. The fort complex includes bastions, gates, and old structures reflecting the city’s Maratha and Adil Shahi history. Visitors can enjoy exploring the fort, taking photographs, and experiencing a glimpse into Solapur’s past."
  },
  {
    "title": "Nagnath Temple",
    "description": "Nagnath Temple, dedicated to Lord Shiva, is an important pilgrimage site in Solapur. Known for its sacred rituals, peaceful ambience, and historic significance, the temple attracts devotees year-round. The temple pond and surrounding gardens enhance the spiritual atmosphere, making it ideal for quiet contemplation and cultural exploration."
  },
  {
    "title": "Pandharpur (Nearby)",
    "description": "Pandharpur, around 70 km from Solapur, is a major pilgrimage town famous for the Vitthal Rukmini Temple. Devotees undertake the Wari pilgrimage during Ashadi Ekadashi, walking hundreds of kilometers in devotion. Visiting Pandharpur from Solapur offers spiritual immersion, witnessing religious processions, and exploring local culture, cuisine, and crafts."
  },
  {
    "title": "Solapur Textile Market",
    "description": "Solapur is famous for its textile industry, particularly Solapur chadars, towels, and handlooms. The local markets offer vibrant shopping experiences where visitors can purchase quality cotton products, traditional crafts, and souvenirs. Exploring these markets provides insight into Solapur’s cultural heritage and thriving handloom industry."
  },
  {
    "title": "Karnataka Border Temples",
    "description": "Around Solapur, several historic temples near the Maharashtra-Karnataka border attract visitors interested in architecture, devotion, and regional history. These temples feature traditional carvings, serene surroundings, and seasonal festivals, providing a cultural and spiritual journey for travelers exploring the area."
  },
  {
    "title": "Siddheshwar Lake",
    "description": "Siddheshwar Lake, located near the Siddheshwar Temple, is a tranquil waterbody offering scenic views, boating opportunities, and peaceful relaxation. Surrounded by gardens and walking paths, the lake provides a refreshing escape within Solapur city. It is ideal for photography, family outings, and quiet contemplation amidst nature and spirituality."
  }
],




"services": [
  {
    "name": "Mumbai Solapur Taxi Service",
    "description": "Mumbai Solapur Taxi Service offers reliable and comfortable long-distance travel from Mumbai to Solapur. With professional drivers, well-maintained vehicles, and flexible booking options, this service ensures a hassle-free journey for families, solo travelers, and corporate passengers."
  },
  {
    "name": "Solapur from Mumbai Cab",
    "description": "Solapur from Mumbai Cab provides direct and convenient travel to Solapur from Mumbai. Passengers can choose from AC sedans and SUVs, with courteous drivers ensuring a safe, smooth, and timely trip for both leisure and business purposes."
  },
  {
    "name": "One Way Cab Mumbai Solapur",
    "description": "One Way Cab Mumbai Solapur is perfect for travelers seeking a single-direction journey. With affordable fares, clean vehicles, and experienced drivers, it offers a comfortable and stress-free travel experience from Mumbai to Solapur."
  },
  {
    "name": "Intercity Cab Mumbai to Solapur",
    "description": "Intercity Cab Mumbai to Solapur connects two major cities with comfort and convenience. The service includes optimized routes, highway-friendly vehicles, and punctual drivers to make long-distance travel smooth and efficient."
  },
  {
    "name": "Affordable Taxi Mumbai Solapur",
    "description": "Affordable Taxi Mumbai Solapur offers budget-friendly options without compromising on comfort or safety. Ideal for families, students, and solo travelers, it provides reliable sedans and SUVs for a comfortable journey."
  },
  {
    "name": "Mumbai Solapur Car Rental",
    "description": "Mumbai Solapur Car Rental allows travelers to rent vehicles for the long journey, including sedans and SUVs. With professional drivers, flexible scheduling, and highway-ready cars, it is a convenient option for both personal and business travel."
  },
  {
    "name": "SUV Cab Mumbai Solapur",
    "description": "SUV Cab Mumbai Solapur is designed for larger groups or families. Spacious interiors, ample luggage space, and comfortable seating make it ideal for long-distance travel to Solapur, ensuring a smooth and safe ride."
  },
  {
    "name": "Sedan Taxi Mumbai Solapur",
    "description": "Sedan Taxi Mumbai Solapur provides a comfortable and economical option for small families or individual travelers. Vehicles like Dzire and Etios offer AC comfort and smooth rides, perfect for a long highway journey."
  },
  {
    "name": "24x7 Cab Mumbai Solapur",
    "description": "24x7 Cab Mumbai Solapur ensures round-the-clock availability for early morning departures, late-night travel, or urgent bookings. Passengers can rely on instant booking, safe vehicles, and experienced drivers anytime."
  },
  {
    "name": "Fastest Cab Mumbai Solapur",
    "description": "Fastest Cab Mumbai Solapur focuses on timely travel with optimized highway routes and professional drivers. Ideal for passengers with tight schedules, this service guarantees quick and comfortable trips between Mumbai and Solapur."
  },
  {
    "name": "Mumbai Solapur Business Cab",
    "description": "Mumbai Solapur Business Cab offers premium comfort and timely service for corporate travelers. Sedans and SUVs with AC, spacious interiors, and professional drivers make it ideal for office trips, client visits, or business meetings."
  },
  {
    "name": "Premium Cab Mumbai Solapur",
    "description": "Premium Cab Mumbai Solapur provides luxury sedans and high-end SUVs for passengers seeking extra comfort and style. With well-maintained vehicles and professional service, it ensures a top-class travel experience."
  },
  {
    "name": "AC Taxi Mumbai Solapur",
    "description": "AC Taxi Mumbai Solapur offers air-conditioned comfort throughout the journey, making long-distance travel pleasant even during hot weather. Suitable for families, corporate travelers, and groups."
  },
  {
    "name": "Safe Cab Mumbai Solapur",
    "description": "Safe Cab Mumbai Solapur prioritizes passenger safety with experienced drivers, well-maintained vehicles, and adherence to traffic rules, ensuring a secure and reliable long-distance journey."
  },
  {
    "name": "Round Trip Mumbai Solapur Cab",
    "description": "Round Trip Mumbai Solapur Cab provides convenient return options for travelers, ensuring a seamless journey to and from Solapur with comfortable vehicles and flexible scheduling."
  },
  {
    "name": "Corporate Cab Mumbai Solapur",
    "description": "Corporate Cab Mumbai Solapur is ideal for business travelers requiring reliable transport between Mumbai and Solapur. Offering AC sedans, SUVs, and professional drivers, it guarantees a smooth and productive journey."
  },
  {
    "name": "Long Route Cab Mumbai Solapur",
    "description": "Long Route Cab Mumbai Solapur specializes in long-distance travel with comfort and efficiency. Passengers enjoy smooth rides, ample legroom, and timely pickups for a hassle-free trip between the two cities."
  }
],

"tableData": [
  ["Mumbai Solapur Taxi Service", "Solapur from Mumbai Cab"],
  ["One Way Cab Mumbai Solapur", "Intercity Cab Mumbai to Solapur"],
  ["Affordable Taxi Mumbai Solapur", "Mumbai Solapur Car Rental"],
  ["SUV Cab Mumbai Solapur", "Sedan Taxi Mumbai Solapur"],
  ["24x7 Cab Mumbai Solapur", "Fastest Cab Mumbai Solapur"],
  ["Mumbai Solapur Business Cab", "Premium Cab Mumbai Solapur"],
  ["AC Taxi Mumbai Solapur", "Safe Cab Mumbai Solapur"],
  ["Round Trip Mumbai Solapur Cab", "Corporate Cab Mumbai Solapur"],
  ["Long Route Cab Mumbai Solapur"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Solapur Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Solapur cab services, perfect for long-distance travel, business trips, family journeys, and comfortable intercity transportation."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs for a smooth and comfortable journey from Mumbai to Solapur."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Solapur route, ensuring safe driving, timely arrivals, and a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included in your Mumbai to Solapur cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route guidance, and any journey-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans to suit your Mumbai to Solapur journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Solapur journey smooth, comfortable, and worry-free."
  }
]





























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Solapur?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Solapur, ensuring a smooth and safe journey to this historical city.',
  },
  {
    question: 'How can I book a cab from Mumbai to Solapur?',
    answer: 'You can easily book a cab from Mumbai to Solapur through our website, mobile app, or by contacting our 24x7 customer support team for a hassle-free experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Solapur cab bookings?',
    answer: 'Shambhu Cabs offers a variety of vehicles for the Mumbai to Solapur journey, including sedans, SUVs, luxury cars, and Tempo Travellers for larger groups.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Solapur journey?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the route to Solapur, ensuring a safe, comfortable, and timely journey.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Solapur trip?',
    answer: 'Yes, you can choose your preferred pickup and drop-off points within Mumbai and Solapur to make your travel experience as convenient as possible.',
  },
  {
    question: 'Is the Mumbai to Solapur cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 cab services for your journey from Mumbai to Solapur, allowing you to travel at any time that suits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Solapur trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure your well-being during the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Solapur cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all bookings from Mumbai to Solapur.',
  },
  {
    question: 'Is customer support available during my Mumbai to Solapur trip?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support to assist you throughout your journey from Mumbai to Solapur.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Joshi',
    feedback: 'The trip from Mumbai to Solapur with Shambhu Cabs was fantastic. The driver was very professional, the car was clean and comfortable, and the journey was smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Sharma',
    feedback: 'Shambhu Cabs provided an excellent service for our Mumbai to Solapur trip. The driver was punctual, the car was well-maintained, and the whole experience was very satisfying.',
    rating: 5,
  },
];













































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const mumbaiSolapurCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Solapur Cab",
  "serviceType": "Outstation / Intercity Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-solapur-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Solapur cab services. Book affordable SUV, sedan, and premium cabs for one-way, round trip, corporate, or business travel, available 24×7.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "680",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-solapur-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Solapur, India" }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Solapur Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Solapur cab services with Shambhu Cabs. Affordable SUV, sedan, premium cabs for one-way, round trip, corporate, and business travel, 24×7 available."
  />

  <meta
    name="keywords"
    content="Mumbai Solapur Taxi Service, Solapur from Mumbai Cab, One Way Cab Mumbai Solapur, Intercity Cab Mumbai to Solapur, Affordable Taxi Mumbai Solapur, Mumbai Solapur Car Rental, SUV Cab Mumbai Solapur, Sedan Taxi Mumbai Solapur, 24x7 Cab Mumbai Solapur, Fastest Cab Mumbai Solapur, Mumbai Solapur Business Cab, Premium Cab Mumbai Solapur, AC Taxi Mumbai Solapur, Safe Cab Mumbai Solapur, Round Trip Mumbai Solapur Cab, Corporate Cab Mumbai Solapur, Long Route Cab Mumbai Solapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(mumbaiSolapurCabSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttosolapur;